import React, { useState, useEffect, useMemo } from 'react';
import clsx from 'clsx';
import './GlobalStyle.css'
import NotFound from '../../../Images/notFound.png';
import { Paper, makeStyles, TableBody, TableRow, TableCell, CircularProgress, Divider, Table, TableHead } from '@material-ui/core';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import { getAllSupplyOrderDocument } from '../../../Backend/firebase/supply-order';
import { parseDate } from '../../Models/CommonFunc';
import { useHistory } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { debounce } from 'lodash';
import { getAllSupplyOrderDocumentForExcel } from '../../../Backend/firebase/supply-bills';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        width: '100%'
    },
    fixedHeight: {
        height: '100%',
    },
}));

function SupplyFrequentlyOrderHistory() {
    const classes = useStyles();
    const history = useHistory()
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const { userData } = CheckUserProvider();
    const [searchQuery, setSearchQuery] = useState("");

    const [records, setRecords] = useState([]);
    const [displayRecords, setDisplayRecords] = useState([]);

    const [recordsForExcel, setRecordsForExcel] = useState([]);
    const [displayRecordsForExcel, setDisplayRecordsForExcel] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [tabIndex, setTabIndex] = useState(0);

    useEffect(async () => {
        var isLogin = localStorage.getItem(process.env.REACT_APP_EMPLOYER_ISLOGIN) || false;
        if (!isLogin || isLogin == "false") {
            history.push("/activity/Login");
        }
    }, [])

    const getLast7DaysDateRange = () => {
        const today = new Date();
        const last7Days = new Date();
        last7Days.setDate(today.getDate() - 7);

        return {
            start: parseDate(last7Days),
            end: parseDate(today),
        };
    };

    function groupAndSortByFrequency(data) {
        const groupedData = {};

        data.forEach(item => {
            const { ProductName, ChemistInfo } = item;

            if (!groupedData[ProductName]) {
                groupedData[ProductName] = {
                    count: 0,
                    orders: [],
                    uniqueChemists: new Set()
                };
            }

            groupedData[ProductName].count += 1;
            groupedData[ProductName].orders.push(item);
            groupedData[ProductName].uniqueChemists.add(ChemistInfo);
        });

        const result = Object.entries(groupedData).map(([productName, data]) => ({
            ProductName: productName,
            Count: data.count,
            UniqueChemists: Array.from(data.uniqueChemists),
            Orders: data.orders
        }));

        result.sort((a, b) => b.Count - a.Count);
        return result;
    }
    
    function groupAndSortByFrequencyForExcel(data) {
        const groupedData = {};
    
        data?.forEach(invoice => {
            const invoiceDate = invoice?.InvoiceDate;
            const chemistEntry = invoice?.chemistEntry;
            
            invoice?.ProductEntry?.forEach(product => {
                const { ProductName } = product;
                
                if (!groupedData[ProductName]) {
                    groupedData[ProductName] = {
                        count: 0,
                        invoiceDates: new Set(),
                        orders: []
                    };
                }
    
                groupedData[ProductName].count += 1;
                groupedData[ProductName].invoiceDates.add(invoiceDate);
                groupedData[ProductName].orders.push({
                    invoiceDate,
                    chemistEntry,
                    product
                });
            });
        });
    
        const result = Object.entries(groupedData)?.map(([productName, data]) => ({
            ProductName: productName,
            Count: data.count,
            InvoiceDates: Array.from(data.invoiceDates),
            Orders: data.orders
        }));
    
        result.sort((a, b) => b.Count - a.Count);
        return result;
    }

    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const { start, end } = getLast7DaysDateRange();
                const getSupplyOrder = await getAllSupplyOrderDocument();
                const todaysMedicine = getSupplyOrder.filter(x => {
                    const supplyDate = parseDate(x.SupplyOrderPostedDateTime);
                    return supplyDate >= start && supplyDate <= end;
                });

                // Example usage
                const groupedAndSortedData = groupAndSortByFrequency(todaysMedicine);
                setRecords(groupedAndSortedData);
                setDisplayRecords(groupedAndSortedData);
                setIsLoading(false);
            } catch (error) {
                console.log("Error Occur in Get Order", error)
                setIsLoading(false);
            }
        }
    }, [userData]);

    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const { start, end } = getLast7DaysDateRange();
                const getSupplyOrder = await getAllSupplyOrderDocumentForExcel();
                const todaysMedicine = getSupplyOrder.filter(x => {
                    const supplyDate = parseDate(x.SupplyBillsPostedDateTime);
                    return supplyDate >= start && supplyDate <= end;
                });

                // Example usage
                const groupedAndSortedData = groupAndSortByFrequencyForExcel(todaysMedicine);
                setRecordsForExcel(groupedAndSortedData);
                setDisplayRecordsForExcel(groupedAndSortedData);
                setIsLoading(false);
            } catch (error) {
                console.log("Error Occur in Get Order", error)
                setIsLoading(false);
            }
        }
    }, [userData]);

    const handleSearch = (query) => {
        setSearchQuery(query);
        if (tabIndex == 0) {
            debouncedFilter(query);
        } else {
            debouncedFilterForExcel(query);
        }
    };

    // Debounced function to filter records from Excel sheet
    const debouncedFilter = useMemo(
        () =>
            debounce((query) => {
                const filtered = records?.filter((item) =>
                    Object.values(item).some((value) =>
                        value?.toString().toLowerCase().includes(query.toLowerCase())
                    )
                );
                setDisplayRecords(filtered);
            }, 300), // Adjust the debounce delay as necessary
        [records]
    );

    // Debounced function to filter recordsForExcel from Excel sheet
    const debouncedFilterForExcel = useMemo(
        () =>
            debounce((query) => {
                const filtered = recordsForExcel?.filter((item) =>
                    Object.values(item).some((value) =>
                        value?.toString().toLowerCase().includes(query.toLowerCase())
                    )
                );
                setDisplayRecordsForExcel(filtered);
            }, 300), // Adjust the debounce delay as necessary
        [records]
    );


    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allProductsAndSales">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Order you have posted till now." />
                            <title>Frequently Order | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-12 inline-style">
                                <h5>Frequently Order List</h5>
                            </div>
                            <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                                <TabList>
                                    <Tab>Supply Product</Tab>
                                    <Tab>Excel Product</Tab>
                                </TabList>
                                <TabPanel>
                                    <div className="branded-tab mt-4">
                                        <div className="col-md-12 mt-4">
                                            <div style={{ position: "relative", width: "100%" }}>
                                                <span style={{
                                                    position: "absolute",
                                                    left: "15px",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    color: "#888",
                                                    fontSize: "18px"
                                                }}>
                                                    🔍 {/* You can replace this with a Font Awesome icon if needed */}
                                                </span>
                                                <input
                                                    type="text"
                                                    placeholder="Search Medicine..."
                                                    value={searchQuery}
                                                    onChange={(e) => handleSearch(e.target.value)}
                                                    style={{
                                                        padding: "10px 10px 10px 40px",  // Adjust padding to accommodate the icon
                                                        width: "100%",
                                                        borderRadius: "8px",
                                                        border: "1px solid #ccc",
                                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                        outline: "none",
                                                        fontSize: "16px",
                                                        transition: "box-shadow 0.3s ease-in-out",
                                                    }}
                                                    onFocus={(e) => (e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)")}
                                                    onBlur={(e) => (e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)")}
                                                />
                                            </div>
                                        </div>

                                        {displayRecords.length > 0 ? <div className="row col-md-12 supply-order-table">
                                            <Table className='table'>
                                                <TableHead>
                                                    <TableCell><b>Product Name</b></TableCell>
                                                    <TableCell><b>Frequency</b></TableCell>
                                                    <TableCell><b>Order Info</b></TableCell>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        displayRecords.map(item => (
                                                            <TableRow key={item.id}>
                                                                <TableCell><b>{item?.ProductName ? item.ProductName : "NA"}</b></TableCell>
                                                                <TableCell><b>{item?.Count ? `${item.Count} times` : "NA"}</b></TableCell>
                                                                <TableCell>{item?.Orders ? item?.Orders.length > 0 ? <>
                                                                    {item?.Orders.map((item) => {
                                                                        return (
                                                                            <div className="historyBox">
                                                                                <p><b>{item.ChemistInfo ? item.ChemistInfo : "NA"}</b> - <b>{item.ProductQuantity ? item.ProductQuantity : "NA"}</b> - <b>{typeof item?.SupplyOrderPostedDateTime == "string" ? item?.SupplyOrderPostedDateTime : parseDate(item?.SupplyOrderPostedDateTime)}</b></p>
                                                                                <Divider className="border__history" />
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </> : 'NA' : 'NA'}</TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </div> : <div className="row col-md-12 mt-3 text-center">
                                            <img src={NotFound} className="notFound" />
                                            <h4>No Order Record Found!</h4>
                                        </div>}
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    <div className="branded-tab mt-4">
                                        <div className="col-md-12 mt-4">
                                            <div style={{ position: "relative", width: "100%" }}>
                                                <span style={{
                                                    position: "absolute",
                                                    left: "15px",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    color: "#888",
                                                    fontSize: "18px"
                                                }}>
                                                    🔍 {/* You can replace this with a Font Awesome icon if needed */}
                                                </span>
                                                <input
                                                    type="text"
                                                    placeholder="Search Medicine..."
                                                    value={searchQuery}
                                                    onChange={(e) => handleSearch(e.target.value)}
                                                    style={{
                                                        padding: "10px 10px 10px 40px",  // Adjust padding to accommodate the icon
                                                        width: "100%",
                                                        borderRadius: "8px",
                                                        border: "1px solid #ccc",
                                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                        outline: "none",
                                                        fontSize: "16px",
                                                        transition: "box-shadow 0.3s ease-in-out",
                                                    }}
                                                    onFocus={(e) => (e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)")}
                                                    onBlur={(e) => (e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)")}
                                                />
                                            </div>
                                        </div>

                                        {displayRecordsForExcel.length > 0 ? <div className="row col-md-12 supply-order-table">
                                            <Table className='table'>
                                                <TableHead>
                                                    <TableCell><b>Product Name</b></TableCell>
                                                    <TableCell><b>Frequency</b></TableCell>
                                                    <TableCell><b>Order Info</b></TableCell>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        displayRecordsForExcel.map(item => (
                                                            <TableRow key={item.id}>
                                                                <TableCell><b>{item?.ProductName ? item.ProductName : "NA"}</b></TableCell>
                                                                <TableCell><b>{item?.Count ? `${item.Count} times` : "NA"}</b></TableCell>
                                                                <TableCell>{item?.Orders ? item?.Orders.length > 0 ? <>
                                                                    {item?.Orders.map((item) => {
                                                                        return (
                                                                            <div className="historyBox">
                                                                                <p><b>{item?.chemistEntry?.storeName ? item?.chemistEntry?.storeName : "NA"}</b> - <b>{item?.product?.ProductQuantity ? item?.product?.ProductQuantity : "NA"}</b> - <b>{item?.invoiceDate ? item?.invoiceDate : "NA"}</b></p>
                                                                                <Divider className="border__history" />
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </> : 'NA' : 'NA'}</TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </div> : <div className="row col-md-12 mt-3 text-center">
                                            <img src={NotFound} className="notFound" />
                                            <h4>No Order Record Found!</h4>
                                        </div>}
                                    </div>
                                </TabPanel>
                            </Tabs>
                        </div>
                    </Paper>
                </div>)
            }
        </>
    )
}

export default SupplyFrequentlyOrderHistory
